import {useState} from 'react';
import PropTypes from 'prop-types';
import {UilEdit} from '@iconscout/react-unicons';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';

export default function AccountPhoneEditor({title, name, value, handlePhone, updateAccountData}) {
  const [edited, setEdited] = useState(false);
  const toggleEdited = () => {
    if (edited) {
      updateAccountData();
    }
    setEdited(!edited);
  };

  const handlePhoneNumber = (newPhone) => {
    handlePhone(newPhone);
  };

  return (
    <div className="profile-item">
      <div className="profile-name">{title}: </div>
      <div className="profile-info">
        {edited ? (
          <PhoneInput
            international
            defaultCountry="US"
            value={value}
            onChange={handlePhoneNumber}
            numberInputProps={{'aria-label': title}}
          />
        ) : (
          <span id={name}>{value}</span>
        )}
      </div>
      <div>
        <button
          type="button"
          className="icon-btn"
          aria-label={edited ? `Save ${title}` : `Edit ${title}`}
          onClick={toggleEdited}
        >
          <UilEdit className={edited ? 'blueberry-icon' : ''} aria-hidden="true" />
        </button>
      </div>
    </div>
  );
}

AccountPhoneEditor.propTypes = {
  title: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  handlePhone: PropTypes.func.isRequired,
  updateAccountData: PropTypes.func.isRequired,
};
